import { render } from "./EntregarPedido.vue?vue&type=template&id=229b712b&scoped=true"
import script from "./EntregarPedido.vue?vue&type=script&lang=js"
export * from "./EntregarPedido.vue?vue&type=script&lang=js"

import "./EntregarPedido.vue?vue&type=style&index=0&id=229b712b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229b712b"]])

export default __exports__